export default __webpack_public_path__ + "static/media/006-american football.a27ed1f3.svg";